import React from 'react';
import ChartBuilderDataSourcesSelect from './ChartBuilderDataSourcesSelect';
import ChartBuilderSourceColumnsSelect from './ChartBuilderSourceColumnsSelect';
import ChartBuilderGroupingSelect from './ChartBuilderGroupingSelect';
import ChartBuilderSegmentingOptions from './ChartBuilderSegmentingOptions';
import ChartBuilderRangeSelect from './ChartBuilderRangeSelect';
import DateRangePicker from '../DateRangePicker/DateRangePicker';
import ChartBuilderChartGuidelines from './ChartBuilderChartGuidelines';
import { addYears, subYears } from "date-fns";

export default class ChartBuilderPrimaryAxisDetails extends React.Component{
  constructor(props){
    super(props);
  };

  render() {
    return (
      <div className="container">
        <h5 className="panel-heading-text" style={{ borderBottom: '1px solid #DFDFDF', paddingBottom: 10, paddingLeft: 0, marginTop: 0, marginBottom: 10 }}>{this.props.primaryAxisDetail.chart_element === 'x-axis' ? I18n.t('horizontal_axis_details') : I18n.t('vertical_axis_details')}</h5>
        <div className="row">
          {this.renderDataSourcesAndDetails()}
          {this.renderLabel()}
          {this.props.primaryAxisDetail.source_detail && this.props.primaryAxisDetail.source_detail.segment_on_model ? this.renderSegmentBy() : this.renderGrouping()}
          {this.renderRange()}
        </div>
        <ChartBuilderChartGuidelines {...this.props} />
      </div>
    );
  };

  renderDataSourcesAndDetails() {
    return(
      <div className="col-md-3">
        <div className="form-group">
          <label style={{display:'block'}}>{`${I18n.t('data_source')}*`}</label>
          <ChartBuilderDataSourcesSelect
          error={this.fieldErrors('Data Source')}
          detail={this.props.primaryAxisDetail}
          dataSources={this.props.dataSources}
          onChangeDataDetailDataSource={this.props.onChangeDataDetailDataSource}
            />
          <div>
            {this.renderSourceDetails()}
          </div>
        </div>
      </div>
    );
  };

  renderSourceDetails() {
    if (this.props.primaryAxisDetail && this.props.primaryAxisDetail.data_source && this.props.primaryAxisDetail.data_source.system_data){
      var primaryColumnOptions = this.props.primaryAxisDetail.data_source.primary_columns.split('|')
      var columnSources = primaryColumnOptions.map((pc) => {
        var columnSource = {}
        this.props.primaryAxisDetail.data_source.source_details.forEach((detail) => {
          detail.data_column_name === pc ? columnSource = Object.assign({}, detail) : null
        });
        return columnSource
      });
      return(
        <div>
          <label style={{ marginTop: '15px' }}>{`${I18n.t('columns_data_type')}*`}</label>
          <ChartBuilderSourceColumnsSelect 
            error={this.fieldErrors('Columns')}
            detail={this.props.primaryAxisDetail}
            columns={columnSources}
            onChangeDataDetailColumn={this.props.onChangeDataDetailColumn}
            primaryDetail={true}
            />
        </div>
      )
    } else if (this.props.primaryAxisDetail && this.props.primaryAxisDetail.data_source && !this.props.primaryAxisDetail.data_source.system_data){
      return (
        <div>
          <label style={{ marginTop: '15px' }}>{`${I18n.t('columns_data_type')}}*`}</label>
          <ChartBuilderSourceColumnsSelect
            error={this.fieldErrors('Columns')}
            detail={this.props.primaryAxisDetail}
            columns={this.props.primaryAxisDetail.data_source.source_details}
            onChangeDataDetailColumn={this.props.onChangeDataDetailColumn}
            externalData={true}
            primaryDetail={true}
          />
        </div>
      )
    };
  };

  renderLabel() {
    if (this.props.primaryAxisDetail && this.props.primaryAxisDetail.data_source && this.props.primaryAxisDetail.data_column_name) {
      return (
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('label')}*`}</label>
            <input type="text" className={this.fieldErrors('Label') ? 'form-control has-errors' : 'form-control'} name={this.props.report_details.chart_type.primary_chart_element === 'x-axis' ? 'x_label' : 'y_label'} value={this.props.report_details.chart_type.primary_chart_element === 'x-axis' && this.props.report_details.x_label ? this.props.report_details.x_label : this.props.report_details.chart_type.primary_chart_element === 'y-axis' && this.props.report_details.y_label ? this.props.report_details.y_label : ''} onChange={this.props.onChangeReportDetails} />
            {
              this.fieldErrors('Label')
                ?
                <div className="help-block">
                  <ul>{I18n.t('cant_be_blank')}</ul>
                </div>
                :
                null
            }
          </div>
        </div>
      );
    };
  };

  renderGrouping(){
    if (this.props.primaryAxisDetail.data_type === 'date' && this.props.primaryAxisDetail.data_source.system_data){
      return (
        <div className="col-md-2">
          <div className="form-group">
            <label>{`${I18n.t('group_by')}*`}</label>
            <ChartBuilderGroupingSelect
              error={this.fieldErrors('Group By')}
              report_details={this.props.report_details}
              detail={this.props.primaryAxisDetail}
              onChangeReportDetails={this.props.onChangeReportDetails}
            />
          </div>
        </div>
      );
    };
  };

  renderSegmentBy(){
    return (
      <div className="col-md-2">
        <div className="form-group">
          <label>{`${I18n.t('include')}*`}</label>
          
          <ChartBuilderSegmentingOptions
            error={this.fieldErrors('Select')}
            dataDetail={this.props.primaryAxisDetail}
            onChange={this.props.onAddSegmentOn}
            // onChecked={this.props.onAddSegmentOn}
            // onUnChecked={this.props.removeSegmentOn}
            segmentModel={this.props.primaryAxisDetail.source_detail.segment_on_model}
            segmentColumn={this.props.primaryAxisDetail.source_detail.segment_on_column}
            dataSourceId={this.props.primaryAxisDetail.data_source.id}
            // selectAll={true}
            multipleSelect={true}
          /> 
         
        </div>
      </div>
    );
  };

  renderRange() {
    if(this.okToRenderRange())
    return (
      // <div>
        <div className="col-md-4">
          {/* <div className="col-md-6" style={{ paddingLeft: '0px', marginRight: '5%' }}> */}
            <div className="form-group">
              <label>{`${I18n.t('default_range')}*`}</label>
              <ChartBuilderRangeSelect
                error={this.fieldErrors('Default Range')}
                report_details={this.props.report_details}
                detail={this.props.primaryAxisDetail}
                onChangeReportDetails={this.props.onChangeReportDetails}
              />
            </div>
          {/* </div> */}
          {this.renderStartAndEndDate()}
        </div>
      // </div>
    );
  };

  renderStartAndEndDate() {
    if (this.props.report_details.x_range === 'specific_dates') {
      return(
        <DateRangePicker
          startDateLabel='begin_date'
          endDateLabel='end_date'
          dateFormat={this.props.date_format}
          onChange={this.props.onSetSpecificDates}
          startDate={this.props.report_details.start_date ? this.props.report_details.start_date  : new Date()}
          startDateError={this.fieldErrors('Start Date')}
          endDate={this.props.report_details.end_date ? this.props.report_details.end_date : addYears(new Date(), 1)}
          endDateError={this.fieldErrors('End Date')}
          minDate={"2020-01-01"}
          maxDate={"2075-12-31"}
          startDatePlaceholder={I18n.t("start")}
          endDatePlaceholder={I18n.t("end")}
          componentVisisibleAction={this.props.toggleDateRangePicker}
        />
      );
    };
  };


  okToRenderRange(){
    var renderRange = false

    if (this.props.primaryAxisDetail && this.props.primaryAxisDetail.data_source && this.props.primaryAxisDetail.data_column_name){
      if(this.props.report_details.x_grouping){
        renderRange = true
      } else if (this.props.primaryAxisDetail.segment_ids && this.props.primaryAxisDetail.segment_ids.length){
        renderRange = true
      } else if (this.props.primaryAxisDetail.data_column_name.includes('relevant')){
        renderRange = true
      };
    };
    return renderRange
  };

  fieldErrors(field) {
    var fieldError = false
    this.props.errors.forEach((error) => {
      if (error.includes(field)) {
        fieldError = true
      };
    });
    return fieldError
  };

};